import { configureStore } from '@reduxjs/toolkit';
import signupReducer from './signupSlice';
import onboardingReducer from './onboardingSlice';

export const store = configureStore({
  reducer: {
    signup: signupReducer,
    onboarding: onboardingReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
